export default __webpack_public_path__ + "static/media/insight.65621be9.svg";